<template>
  <div class="report-category">
    <toggle-button
      :value="open"
      class="report-category__toggler"
      :disabled="category.reportsCount === 0"
      disabled-popover="Пустая категория"
      @input="$emit('toggle', category)"
    />

    <div class="report-category__data">
      <div class="report-category__name">
        {{ category.name }}
      </div>
    </div>

    <div class="report-category__actions">
      <c-button
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          boundary: 'window',
          content: 'Редактировать',
          placement: 'top',
        }"
        class="report-category__edit"
        size="iconic"
        icon="edit"
        @click="$emit('edit', category)"
      />

      <span
        v-if="category.reportsCount > 0"
        :id="`report-category-remove-${category.id}`"
        class="report-category__remove"
      >
        <c-button :icon="{ icon: 'trash', color: 'secondary' }" size="iconic" disabled />
      </span>

      <c-button
        v-else
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          boundary: 'window',
          content: 'Удалить',
          placement: 'top',
        }"
        :icon="{ icon: 'trash', color: 'secondary' }"
        class="report-category__remove"
        size="iconic"
        @click="$emit('remove', category)"
      />

      <b-popover placement="top" triggers="hover blur" :target="`report-category-remove-${category.id}`">
        <error-feedback
          class="m-0 empty-category-tooltip"
          text="В данный момент удаление невозможно, так как категория содержит данные. Сначала перенесите все данные из категории."
        ></error-feedback>
      </b-popover>

      <c-button
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          boundary: 'window',
          content: 'Переместить',
          placement: 'top',
        }"
        class="report-category__move"
        size="iconic"
        icon="arrows-constructor"
      />
    </div>
  </div>
</template>

<script>
import ToggleButton from "@/components/controls/toggle-button";
import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: {
    ToggleButton,
    CButton,
    ErrorFeedback,
  },
  props: ["category", "open"],

};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.report-category {
  display: flex;
  align-items: center;
  min-height: 35px;
  padding: 8px 16px;
  // padding-right: 10px;
  border: 1px solid $color-border-light;
  cursor: pointer;

  &__toggler {
    margin-right: 15px;
  }

  &__data {
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  &__name {
    font-size: 15px;
    font-weight: 500;
    margin-right: 16px;
    flex-grow: 1;
  }

  &__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  &__edit {
    margin-right: 16px;
  }

  &__remove {
    margin-right: 15px;
    transform: translateY(-2px);
  }
}
</style>
